import { Outlet } from "@tanstack/react-router";
import { AuthLayout } from '../components/layouts/AuthLayout';
import EventsProvider from '../libs/events/EventsProvider';

export const AuthenticatedView = () => {
    return (
        <EventsProvider>
            <AuthLayout>
                <Outlet />
            </AuthLayout>
        </EventsProvider>
    );
}
